"use client";
'use strict';

var React = require('react');

function doesRefContainNode(ref, event) {
    return !(ref?.current == null || ref.current.contains(event.target));
}
/**
 * React hook that handles click events outside a specific DOM element, like a div. A handler is invoked when a click or touch event happens outside the referenced element.
 *
 * @param ref
 * @param handler
 */
const useOutsideClick = (ref, handler, enabled = true) => {
    React.useEffect(() => {
        const listener = (event) => {
            if (!enabled) {
                return;
            }
            if (Array.isArray(ref)) {
                if (ref.some((item) => !doesRefContainNode(item, event))) {
                    return;
                }
            }
            else if (!doesRefContainNode(ref, event)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler, enabled]);
};

exports.useOutsideClick = useOutsideClick;
//# sourceMappingURL=useOutsideClick.js.map
